exports.path = 'https://panel.toyagroup.pl/api/api/';

exports.bmPath = 'https://panel.toyagroup.pl/api/bm/';

exports.localPath = 'http://localhost:8000/api/';

exports.bmTestPath = 'https://easysms-main-accept.blue.pl/gateway/rest/smses';

exports.mMainPath = 'https://easysms-main.blue.pl/gateway/rest/smses';

exports.testPassword = 'QweHjkMnb7';

exports.testUsername = 'toyatest';

exports.mainPassword = 'fdRe4yX5sa';

exports.mainUsername = 'toyaonline';

exports.mongoPass = 'mongoDBhaslo';

// exports.mongoAtlas = 'mongodb+srv://Erem:mongoDBhaslo@clustererem-2ilyb.mongodb.net/Alert';

exports.mongoDB = 'mongodb://127.0.0.1:27017/Alert';

// exports.secretKey = '6LdIZMYcAAAAAFiTH5ggD4pV6CQksckX8jVoD1hW';

exports.secretKey = '6Lex8MkcAAAAAN_HjtwT3UFcVOKJwlJmJWy5oyam';

exports.serverURI = '/api';